import { carVerticalName, homecontentVerticalName, whitelabelBrandcodes } from './constants';
import * as CTMCarBranding from './ctm/car/content';
import * as CTMHomeContentsBranding from './ctm/home-contents/content';
import * as CHOOCarBranding from './choo/car/content';
import * as CHOOHomeContentsBranding from './choo/home-contents/content';
import * as ISLTCarBranding from './islt/car/content';
import * as ISLTHomeContentsBranding from './islt/home-contents/content';
import * as LOCALCarBranding from './local/car/content';
import * as LOCALHomeContentsBranding from './local/home-contents/content';
// For now a simple data structure for the mapping.
// be nice if we can use dynamic imports and have it only requested by the UI on demand
const factoryKey = ({ verticalName, brandCode }) => `${brandCode}|${verticalName}`;
const factoryMapper = new Map();
factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.CTM, verticalName: carVerticalName }), CTMCarBranding);
factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.CTM, verticalName: homecontentVerticalName }), CTMHomeContentsBranding);

factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.CHOO, verticalName: carVerticalName }), CHOOCarBranding);
factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.CHOO, verticalName: homecontentVerticalName }), CHOOHomeContentsBranding);

factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.ISLT, verticalName: carVerticalName }), ISLTCarBranding);
factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.ISLT, verticalName: homecontentVerticalName }), ISLTHomeContentsBranding);

factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.LOCAL, verticalName: carVerticalName }), LOCALCarBranding);
factoryMapper.set(factoryKey({ brandCode: whitelabelBrandcodes.LOCAL, verticalName: homecontentVerticalName }), LOCALHomeContentsBranding);

/**
 * @name DisclaimerFactory
 * @function
 * @param {Object} states
 * @param states.comparisonUrl
 * @param states.fsgUrl
 * @returns {String} interpolated html
 */

/***
 * @typedef {Object} BrandConfiguration
 * @prop {function()} partnerBrands
 * - gets the partners for Brand
 * @prop {function()} footerDisclaimer
 * - creates the footer disclaimer.
 * - When the attribute [data-id="expandable"] is set on an element section of the content, it will make it expandable by the "show more|less" button.
 * @prop {function()} crossSellOtherVerticalsOnResults
 * - get NoResultsOverlayGenerice message config for the brand
 * @prop {function()} showNoResultsOverlayGenericMessage
 * - get showNoResultsOverlayGenericMessage
 * - config to cross selling other verticals for a brand in results page
 * @prop {function()} contactDetailOptInPrivacyMessage
 * - config to create the opt in privacy text. Includes option to handle trusted partner modal trigger ([data-id=trustedPartnersOpen])
 *   and opening hours modal trigger ([data-id=callCentreHoursOpen])
 * @prop {function()} trustedPartnerContent
 * - get trustedPartnerContent
 */


/***
 * Brand Configuration Factory generates the configuration required by a certain brand code and its verticalAlign
 * @param {String} verticalName - eg: home, car
 * @param {String} brandCode - eg: choo, ctm
 * @returns {BrandConfiguration}
 */
const BrandContentFactory = (brandCode, verticalName) => {
    const configurationFactory = factoryMapper.get(factoryKey({ verticalName, brandCode }));

    if (!configurationFactory) {
        throw new Error(`No brand configuration found for BrandCode:${brandCode} | VerticalName:${verticalName}`);
    }

    const configurationFactoryResult = {
        footerDisclaimer: configurationFactory.footerDisclaimer,
        partnerBrands: configurationFactory.partnerBrands,
        crossSellOtherVerticalsOnResults: configurationFactory.crossSellOtherVerticalsOnResults,
        showNoResultsOverlayGenericMessage: configurationFactory.showNoResultsOverlayGenericMessage,
        contactDetailOptInPrivacyMessage: configurationFactory.contactDetailOptInPrivacyMessage,
        trustedPartnerContent: configurationFactory.trustedPartnerContent,
        enableResultsFeatureAccordion: configurationFactory.enableResultsFeatureAccordion,
        resultsScreenDefaultDisplayMode: configurationFactory.resultsScreenDefaultDisplayMode
    };

    if (Object.entries(configurationFactoryResult).some(([key, value]) => !key || !value)) {
        throw new Error(`Invalid configuration for this factory BrandCode:${brandCode} | VerticalName:${verticalName} | Invalid Key(s): ${Object.entries(configurationFactoryResult).filter(([key, value]) => !key || !value).map(([key, value]) => [key]).join(', ')}`);
    }

    return configurationFactoryResult;
}

export { BrandContentFactory };
